import { useState } from 'react';
import { Provider } from 'react-redux';
import store from './store';

import ExchangeTemplate from './components/templates/exchanges';

import BottomNav from './components/organisms/bottomNav';
import Exchanges from './components/organisms/exchange';
import Compare from './components/organisms/compare';
import Favorite from './components/organisms/favorite';

import { Fab } from 'react-tiny-fab';

import useMobile from './hooks/useMobile';
import ThemeContext, { theme } from './context/theme';

import { FaSun, FaRegMoon } from "react-icons/fa";

import './App.css';
import 'react-tiny-fab/dist/styles.css';

function App() {
  // const t = useContext(ThemeContext);
  const [select, setSelect] = useState<number>(0);
  const [themeMode, setThemeMode] = useState<string>('dark');
  const [isMobile] = useMobile();

  const bottoms: string[] = ['업비트', '빗썸', '코빗', '즐겨찾기'];

  const isDark = themeMode === 'dark';

  return (
    <Provider store={store}>
      <ThemeContext.Provider value={isDark ? theme.dark : theme.light}>
        <div style={{backgroundColor: isDark ? theme.dark.background.default : theme.light.background.default, height: window.innerHeight}}>
          <ExchangeTemplate
            compare={
              <Compare />
            }
            exchanges={[
              <Exchanges.Upbit title={!isMobile} />,
              <Exchanges.Bithumb title={!isMobile} />,
              <Exchanges.Cobit title={!isMobile} />,
              <Favorite title={!isMobile} />
            ]}
            bottomNav={
              <BottomNav
                items={bottoms}
                height={40}
                select={select}
                onChange={(idx: number) => setSelect(idx)}
              />
            }
            select={select}
            isMobile={isMobile}
            fab={
              <Fab
                mainButtonStyles={{ backgroundColor: isDark ? theme.dark.background.bottomNav : theme.light.background.bottomNav }}
                onClick={() => {
                  setThemeMode(isDark ? 'light' : 'dark');
                }}
                icon={isDark ? <FaRegMoon /> : <FaSun />}
              />
            }
          />
        </div>
      </ThemeContext.Provider>

    </Provider>
  );
}

export default App;
